import { Component, inject, OnInit } from '@angular/core';
import { AccordionGroupMeta, genTinyGUID } from '@cudirect/shared-ui-library';
import { LoanProtectionOption } from './loan-protection-option-model';
import { StatefulValue } from '@workflow/class/stateful-value.class';
import { UtilitiesService } from '@shared/service/utilities.service';
import { StatefulService } from '@app/service/stateful.service';

/**
 * different type of field layout
 */
@Component({
  selector: 'ecp-ola-loan-protection-options',
  templateUrl: './ola-loan-protection-options.component.html'
})
export class OlaLoanProtectionOptionsComponent implements OnInit {
  private readonly statefulService = inject(StatefulService);

  public loanProtectionOptionList: LoanProtectionOption[] = [];
  /** modalContent */
  public modalContent: LoanProtectionOption;
  // for accordian
  public accordionGroupMeta = new AccordionGroupMeta();
  /** showModel */
  public showModel: boolean;
  /** used to associate link with modal */
  public modalIndex: number;

  constructor(public utilitiesService: UtilitiesService) {}

  public ngOnInit(): void {
    this.setOptions();
  }

  public get isLoanProtectionsAvailable(): boolean {
    return !!(this.loanProtectionOptionList && this.loanProtectionOptionList.length > 0);
  }

  public uniqueModalId(): string {
    return 'loan-protection-modal-' + genTinyGUID();
  }

  private setOptions(): void {
    const allSize = StatefulValue.arraySize('ola:olaApplicationInformation/loanProtectionOption/loanProtectionCheck');
    this.modalContent = {} as LoanProtectionOption;
    this.loanProtectionOptionList = [];
    for (let i = 0; i < allSize; i++) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const isChecked: any = this.statefulService.wrap(
        'ola:olaApplicationInformation/loanProtectionOption/loanProtectionCheck/$/isChecked',
        i
      ).value;
      this.loanProtectionOptionList.push({
        heading: this.statefulService.wrap('ola:olaApplicationInformation/loanProtectionOption/loanProtectionCheck/$/heading', i)
          .valueStringOnly,
        information: this.statefulService.wrap('ola:olaApplicationInformation/loanProtectionOption/loanProtectionCheck/$/information', i)
          .valueStringOnly,
        isChecked,
        question: this.statefulService.wrap('ola:olaApplicationInformation/loanProtectionOption/loanProtectionCheck/$/question', i)
          .valueStringOnly
      });
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public onLoanProtectionChange(event: any, index: any): void {
    if (index >= 0) {
      this.statefulService.wrap('ola:olaApplicationInformation/loanProtectionOption/loanProtectionCheck/$/isChecked', index).value =
        event.target.checked;
    }
  }
  public viewMore(modalContent: LoanProtectionOption, index: number): void {
    this.modalContent = {
      heading: modalContent && modalContent.heading,
      information: modalContent && modalContent.information
    };
    this.modalIndex = index;
    this.showModel = true;
  }
}
